import { ResponseUser, User } from '../model/userSchema';

export const modifyAuthData = (data: ResponseUser): User => ({
    ...data,
    tokenExpirationDate: Date.now() + data.tokenLifetime,
});
